import React, { useState, useEffect, useRef } from 'react';
import { i18n } from '../../i18n/translate';
import { Layout } from '../../core';
import { FloatingLabelFormField } from '../../material';
import { SelectControl } from '../Form/Controls/SelectControl';
import { GenericModal } from '../GenericModal';
import { ApiUtil } from '../..';

export const SchoolModal: React.FC<any> = ({ homeroomDomain, user, showSchoolModal, toggleSchoolModal }) => {
  const containerRef = useRef(null);
  const schools = user?.schools;
  const [isLoading, setLoading] = useState<boolean>(true);
  const [selectedSchool, setSelectedSchool] = useState(user?.current_school);

  const homeroomToken = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('Homeroom_access_token');

  const switchCurrentSchool = async selectedSchool => {
    if (!selectedSchool) return;
    try {
      const response = await ApiUtil.requestExternalData(
        `${homeroomDomain}/api/v3/me/switch_school/${selectedSchool.id}`,
        homeroomToken,
        false,
        'POST',
        {},
        false
      );

      if (response) {
        window.location.href = '/teacher/explore_courses';
      } else {
        console.error('Failed to switch school');
      }
    } catch (error) {
      console.error('Error switching school:', error);
    }
  };

  useEffect((): void => {
    isLoading && containerRef && containerRef.current && setLoading(false);
  }, [isLoading]);

  useEffect((): void => {
    i18n && i18n.loadTranslations();
  }, []);

  const onCancel = (): void => {
    toggleSchoolModal();
  };

  const onSaveSchool = () => {
    switchCurrentSchool(selectedSchool);
  };

  if (!schools) return null;

  return (
    <Layout ref={containerRef}>
      <GenericModal
        canClose={true}
        modalClass="school-selection-modal"
        footerCloseButton={{
          id: 'close-schools-modal-button',
        }}
        onClose={onCancel}
        saveButtonConfig={{
          disabled: !schools?.length,
          id: 'apply-courses-modal-button',
          saveAction: onSaveSchool,
          saveText: i18n.t('Save'),
          variant: 'primary',
        }}
        show={showSchoolModal}
        title={i18n.t('Choose Your School')}
        stickyFooter={false}
      >
        <div className="school-modal-section">
          <FloatingLabelFormField required={true} name="new_school" caption={i18n.t('School')}>
            <SelectControl
              labelKey="name"
              valueKey="id"
              options={schools}
              onChange={school => {
                setSelectedSchool(school);
              }}
              defaultValue={schools.find(school => school.id === user.current_school.id)}
            />
          </FloatingLabelFormField>
        </div>
      </GenericModal>
    </Layout>
  );
};
